export const RoleCode = {
  PartnerDistributor: 'PARTNER_DISTRIBUTOR',
  PartnerBranch: 'PARTNER_BRANCH',
  PartnerSales: 'PARTNER_SALES',
  HosinOwner: 'HOSIN_OWNER',
  HosinManager: 'HOSIN_MANAGER',
  HosinSales: 'HOSIN_SALES',
  AccountAdmin: 'ACCOUNT_ADMIN',
} as const

export const PermissionCode = {
  DashboardView: 'dashboard.view',
  CaseList: 'case.list',
  CaseRead: 'case.read',
  CaseCreate: 'case.create',
  CaseOperate: 'case.operate',
  CaseSearch: 'case.search',
  CaseLoanSystemView: 'case.loan_system.view',
  CaseCancel: 'case.cancel',
  CaseTransfer: 'case.transfer',
  ContactLogView: 'contact_log.view',
  ContactLogCreate: 'contact_log.create',
  AccountManage: 'account.manage',
  RosterManage: 'roster.manage',
  MenuRosterManagement: 'menu.roster.management',
  MenuCaseHome: 'menu.case.home',
  MenuIncomingTemporary: 'menu.incoming.temporary',
  MenuWebTemporary: 'menu.web.temporary',
  MenuWebToContact: 'menu.web.to_contact',
  MenuWebConfirmed: 'menu.web.confirmed',
  MenuCaseReady: 'menu.case.ready',
  MenuCaseAccepted: 'menu.case.accepted',
  MenuCaseReviewing: 'menu.case.reviewing',
  MenuCaseReturned: 'menu.case.returned',
  MenuCaseCanceled: 'menu.case.canceled',
  MenuCaseApprovedPendingContract: 'menu.case.approved_pending_contract',
  MenuCaseRejected: 'menu.case.rejected',
  MenuCasePendingSupplement: 'menu.case.pending_supplement',
  MenuCaseConditional: 'menu.case.conditional',
  MenuCaseSelfCanceled: 'menu.case.self_canceled',
  MenuCaseTransfer: 'menu.case.transfer',
  MenuCaseAppropriationPending: 'menu.case.appropriation_pending',
  MenuCaseAppropriation: 'menu.case.appropriation',
  MenuCaseAccounting: 'menu.case.accounting',
  MenuCaseSupplement: 'menu.case.supplement',
  MenuCaseSupplementReturn: 'menu.case.supplement_return',
  MenuCaseAppropriationReturn: 'menu.case.appropriation_return',
  MenuReportDailyTrend: 'menu.report.daily_trend',
  MenuReportDailyCustomerSubmissionTrend: 'menu.report.daily_customer_submission_trend',
  MenuReportDailySalesSubmissionTrend: 'menu.report.daily_sales_submission_trend',
  MenuReportDailyReviewSubmissionTrend: 'menu.report.daily_review_submission_trend',
  MenuReportDailyPendingCaseTrend: 'menu.report.daily_pending_case_trend',
  MenuReportDailyWebsiteCaseSummary: 'menu.report.daily_website_case_summary',
  MenuReportPerformance: 'menu.report.performance',
  MenuReportRealtime: 'menu.report.realtime',
  MenuReportMarketing: 'menu.report.marketing',
  MenuReportSubmissionFlow: 'menu.report.submission_flow',
  MenuReportDailyWebsiteTraffic: 'menu.report.daily_website_traffic',
  MenuReportSalesAppropriation: 'menu.report.sales_appropriation',
  MenuReportSalesPerformance: 'menu.report.sales_performance',
  MenuDownloadCenter: 'menu.download.center',
  MenuAdminUsers: 'menu.admin.users',
  MenuAdminPermissions: 'menu.admin.permissions',
  MenuAdminUat: 'menu.admin.uat',
  MenuAdminContactResultCodes: 'menu.admin.contact_result_codes',
} as const

export type PermissionCodeValue = (typeof PermissionCode)[keyof typeof PermissionCode]
